module.exports = __webpack_public_path__ + "img/new-icon-belum-diproses.64c8a9a2.svg";